module.exports = __webpack_public_path__ + "img/detail3.0299acc1.jpg";